import { ISpineData, SpineBase, clone, IObject, ingenuity, Container } from "@quest/base-core";
import { BigWinView } from "@quest/murka-games-behavior-panther/dist";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
export class BigWinViewGame extends BigWinView {
  bigWinCharContainerPortrait:Container;
  bigWinContainer:Container;
  constructor(viewJson: IObject) {
    super(viewJson);
    this.resize({ data: ingenuity.deviceEnv.update() });
  }

  // Overrided to initialize game end elements
  protected initialiseElements(): void {
    super.initialiseElements();
    this.bigWinCharContainerPortrait = this.getContainerByID("bigWinCharContainerPortrait");
    this.bigWinContainer = this.getContainerByID("bigWinContainer");
    this.bigWinTextContainer = this.getContainerByID("bigWinCharContainer");
  }

  // Overrided to apply max scale
  protected resize(evt: any): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
      const heightScale: number = innerHeight / ingenuity.configData.height;
      this.scale.set(heightScale);
      this.scaleComponents();
    }
    this.changeMeterParent();
  }

  // Add to create spine
  public createBigWinSpine(spineId: string): SpineBase {
    let bigWinObj: ISpineData = clone(this.json[spineId]);
    bigWinObj.type = "spine";
    //bigWinObj.id = 'bigwin'
    let bigWinSpine: SpineBase = this.createSpine(bigWinObj);
    bigWinSpine.visible = false;
    return bigWinSpine;
  }
}
